export default __webpack_public_path__ + "static/media/icon-linux.71e896dd.png";